import { useQuery } from "@tanstack/react-query";
import { Demos } from "@/api/demos";

/** A playable/viewable URL for a demo. Signed links last 30 minutes, so cached
 *  ones are refreshed after 20. */
export function useDemoUrl(id: string, enabled = true) {
  return useQuery({
    queryKey: ["demo-link", id],
    queryFn: () => Demos.link(id),
    enabled,
    staleTime: 20 * 60_000,
    select: (l) => l.url,
  });
}
